/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import {Button} from 'react-bootstrap';

class RetryPhoneVerificationStart extends React.Component<Props> {

	static defaultProps: Props = {
		buttonText: '',
		onRetryPhoneVerificationStart: () => {
			// do nothing
		},
		submitDisabled: false
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<Button type="button" variant="primary" onClick={props.onRetryPhoneVerificationStart} disabled={props.submitDisabled}>
				{props.buttonText}
			</Button>
		);
	}
}

export default RetryPhoneVerificationStart;
